/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class AngularLoadService {
        private document: any;

        constructor(private $document, private $q, private $timeout) {
            this.document = $document[0];
        }

        private loader(createElement) {
            var promises = {};

            return function (url) {
                var self = this;
                if (typeof promises[url] === 'undefined') {
                    var deferred = this.$q.defer();
                    var element = createElement(url);

                    element.onload = element.onreadystatechange = function (e) {
                        if (element.readyState && element.readyState !== 'complete') {
                            return;
                        }

                        self.$timeout(() => {
                            deferred.resolve(e);
                        });
                    };
                    element.onerror = function (e) {
                        this.$timeout(() => {
                            deferred.reject(e);
                        });
                    };

                    promises[url] = deferred.promise;
                }

                return promises[url];
            };
        }


        /**
         * Dynamically loads the given script
         * @param src The url of the script to load dynamically
         * @returns {*} Promise that will be resolved once the script has been loaded.
         */
        public loadScript = this.loader(src => {
            var script = document.createElement('script');

            script.src = src;

            document.body.appendChild(script);
            return script;
        });

        /**
         * Dynamically loads the given CSS file
         * @param href The url of the CSS to load dynamically
         * @returns {*} Promise that will be resolved once the CSS file has been loaded.
         */
        public loadCSS = this.loader(href => {
            var style = document.createElement('link');

            style.rel = 'stylesheet';
            style.type = 'text/css';
            style.href = href;

            document.head.appendChild(style);
            return style;
        });
    }
}

warsApp.registerService('AngularLoadService', ['$document', '$q', '$timeout']);